import { SortOrder } from '@constants/common.constants';

import { HISTORICAL_NOTICES_SORT_FIELDS } from './notices.types';

export const HISTORICAL_NOTICES_INITIAL_PAGE_NUMBER = 0;

export const HISTORICAL_NOTICES_DEFAULT_SORT_COLUMN = HISTORICAL_NOTICES_SORT_FIELDS.DATE_TIME;

export const HISTORICAL_NOTICES_DEFAULT_SORT_ORDER = SortOrder.DESC;
